export const satelliteNodesPath = '/satellite-nodes'
